import { actions, reducer } from './reducer';
import { deleteBookWatcher as saga } from './sagas';
import * as selectors from './selectors';

export const bookDeletionModel = { actions, reducer, selectors, saga };
